import { GuardRoute } from '../components/guard/guard-route';
import { PageLayout } from '../components/layouts/page-layout/page-layout';
import { PermissionActions } from '../enums/permissions';
import { validateAction } from '../hooks/tools/use-guard';
import routes from '../routes/index.routes';
import { MyLinks } from '../../pages/my-links/index/my-links.page';

export const MyLinksRouter = [
	{
		element: <PageLayout />,
		children: [
			{
				path: routes.myLinks.index(),
				element: (
					<GuardRoute validate={validateAction([PermissionActions.ReportRead])}>
						<MyLinks />
					</GuardRoute>
				),
			},
		],
	},
];
